import React from 'react';
//import {authRoles} from '../../auth';

export const PatronalUpdateConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['admin', 'rh', 'rh_not_signer'],
    routes: [{
        path: '/user-patronal-details/:id',
        component: React.lazy(() =>
            import ('./PatronalUpdate'))
    }]
};